// extracted by mini-css-extract-plugin
export default {"topMenu":"TopMenu_topMenu__x+7X-","moreInfo":"TopMenu_moreInfo__xxXP-","logo":"TopMenu_logo__ipIsT","menuTrigger":"TopMenu_menuTrigger__21UZp","closed":"TopMenu_closed__sKbAe"};